var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.iframeUrl)?_c('type-wrapper',{staticClass:"type-N",attrs:{"regular":""}},[_c('iframe',{staticClass:"type-N-iframe",attrs:{"src":_vm.iframeUrl,"frameBorder":"0","width":"100%","height":"100%"}})]):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }